import './line-item';
import '../form/cart-form';

import { html, LitElement, TemplateResult } from "lit";
import { customElement, state } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import { CartData, cartStore, LineItemData } from '../../_stores/cart-store';
import { SignalWatcher } from '@lit-labs/signals';

@customElement('cart-element')
export class CartElement extends SignalWatcher(LitElement) {

    // Props

    @state()
    private _crsf: string = '';

    // Lifecycle Hooks

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('Cart');
        const slot: HTMLElement | null = this.querySelector('[slot="crsf"]');
        if (slot) {
            this._crsf = slot.innerHTML;
            slot.remove();
        }
    }
    
    // Render

    render() {
        const cartData = cartStore.data.get();
        return html`
            <section class="Cart-body">
                ${ cartData && cartData.lineItems.length ? this.bodyTemplate(cartData) : this.alertTemplate() }
            </section>
            ${ cartData && cartData.lineItems.length ? this.footerTemplate() : '' }
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Templates

    bodyTemplate(cartData: CartData): TemplateResult {
        return html`
            ${ 
                repeat(cartData.lineItems, 
                    (lineItem) => lineItem.id, 
                    (lineItem) => this.lineItemTemplate(lineItem)) 
            }
        `;
    }

    alertTemplate(): TemplateResult {
        return html`
            <div class="Alert">
                Your cart is empty!
            </div>
        `;
    }

    footerTemplate(): TemplateResult {
        return html`
            <footer class="Cart-footer">
                <cart-form></cart-form>
            </footer>
        `;
    }

    lineItemTemplate(lineItem: LineItemData): TemplateResult {
        return html`
            <line-item
                id="${ lineItem.id }"
                description="${ lineItem.description }"
                total="${ lineItem.priceAsCurrency }"
                qty="${ lineItem.qty }"
                productId="${ lineItem.snapshot.product.id }"
                productUrl="${ lineItem.snapshot.product.url }">
            </line-item>
        `;
    }

}
